import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { useState } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import TimeContractPickerModal from '@features/reservation/components/TimeContractPickerModal';
import Header from '@features/reservation/components/Header';
import ProcessProgress from '@features/reservation/components/process/ProcessProgress';
import { useStartStandardReservation } from '@features/reservation/hooks/useStartStandardReservation';

import DurationCustomCard from '@shared/components/duration/DurationCustomCard';
import DurationPresetCard from '@shared/components/duration/DurationPresetCard';
import { CUSTOM_DURATION, PRESET_DURATIONS } from '@shared/constants/parkingDurations';
import { useParkingSearchStore } from '@shared/stores/useParkingSearchStore';
import PageFrame from '@shared/components/page/PageFrame';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function DurationPage() {
  const navigate = useNavigate();
  const testId = TestId.root('reservation.durationPage');
  const setParkDuration = useParkingSearchStore((state) => state.setParkDuration);
  const startStandardReservation = useStartStandardReservation();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const handleDurationSelect = (minutes: number) => {
    setParkDuration(minutes);
    startStandardReservation();
  };

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    startStandardReservation();
  };

  const handleOpenChange = (open: boolean) => {
    if (open) {
      handleOpenDrawer();
    } else {
      handleCloseDrawer();
    }
  };

  const handleBack = () => {
    navigate(generatePath(ROUTE_PATHS[RouteName.RESERVATION_QR]));
  };

  return (
    <PageFrame testId={testId} onGoBack={handleBack}>
      <div className="flex flex-1 flex-col justify-between pb-6">
        <div className="flex flex-col gap-6">
          <ProcessProgress currentStep={1} testId={testId.append('progress')} />

          <Header
            title={tr('reservations:duration_page.title')}
            subtitle={tr('reservations:duration_page.subtitle')}
            testId={testId.append('title')}
          />
        </div>

        <div className="flex flex-col gap-3">
          {PRESET_DURATIONS.map((minutes) => (
            <DurationPresetCard
              key={minutes}
              color="white"
              minutes={minutes}
              onClick={() => handleDurationSelect(minutes)}
              testId={testId.append(`duration${minutes}`)}
              className="h-20"
            />
          ))}

          <DurationCustomCard
            color="white"
            minutes={CUSTOM_DURATION}
            onClick={handleOpenDrawer}
            testId={testId.append('durationCustom')}
            className="h-20"
          />
        </div>
      </div>
      <TimeContractPickerModal
        open={isDrawerOpen}
        onOpenChange={handleOpenChange}
        testId={testId.append('durationDrawer')}
      />
    </PageFrame>
  );
}
